<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>绩效设置</el-breadcrumb-item>
    </el-breadcrumb>

    <div style="display: flex;justify-content: space-between">
      <div style="width: 20%">
        <div class="left_inner_con">
          <el-input size="mini"
                    style="margin-bottom: 10px;position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
          </el-input>
          <el-tree
            :data="orgList"
            :props="treeProps"
            :highlight-current="true"
            node-key="id"
            :filter-node-method="filterNode"
            show-checkbox
            @check="handleCheckChange"
            ref="tree">
          </el-tree>
        </div>
      </div>
      <div style="rgb(222,222,222);width: 100%;height: 600px;background-color: #eff3f8">
        <el-button size="mini" @click="createShopPerfRule">配置门店绩效管理规则</el-button>
        <el-card>
            <div>
              <span style="font-size: 14px;color: #8c939d;">绩效类目:</span>
              <el-select v-model="selectPerfTypeId" clearable value filterable placeholder="请选择"
                         style="margin-left: 5px;width: 40%" size="mini" @change="getPerfType">
                <el-option
                  v-for="perfType in perfTypeList"
                  :key="perfType.type"
                  :label="perfType.label"
                  :value="perfType.label">
                </el-option>
              </el-select>
            </div>
            <div style="display:flex;justify-content: flex-start;margin-top: 5px;">
              <span style="font-size: 14px;color: #8c939d;width: 8%">内容明细:</span>
              <el-input v-model="perfRule.content" type="textarea"  size="mini"></el-input>
            </div>
          <div style="width: 100%; display: flex;justify-content: flex-start;margin-top: 5px;">
            <div>
              <span style="font-size: 14px;color: #8c939d;" >奖励方式:</span>
              <el-select v-model="selectAwardId" clearable value filterable placeholder="请选择"
                         style="margin-left: 5px;width: 60%" size="mini" @change="getJlType">
                <el-option
                  v-for="award in awardList"
                  :key="award.id"
                  :label="award.label"
                  :value="award.label">
                </el-option>
              </el-select>
            </div>
            <div>
              <span style="font-size: 14px;color: #8c939d;" >奖励数额:</span>
              <el-input v-model="perfRule.awardValue"  size="mini" style="width: 60%;"></el-input>
            </div>
            <div >
              <span style="font-size: 14px;color: #8c939d;">加分:</span>
              <el-input v-model="perfRule.addScore"  size="mini" style="width: 60%;"></el-input>
            </div>
            <div>
              <span style="font-size: 14px;color: #8c939d;">惩罚方式:</span>
              <el-select v-model="selectCfId" clearable value filterable placeholder="请选择"
                         style="margin-left: 5px;width: 60%" size="mini" @change="getCfType">
                <el-option
                  v-for="award in cfList"
                  :key="award.id"
                  :label="award.label"
                  :value="award.label">
                </el-option>
              </el-select>
            </div>
            <div>
              <span style="font-size: 14px;color: #8c939d;" >惩罚数额:</span>
              <el-input v-model="perfRule.cheFaValue"  size="mini" style="width: 60%;"></el-input>
            </div>
            <div >
              <span style="font-size: 14px;color: #8c939d;">减分:</span>
              <el-input v-model="perfRule.subScore"  size="mini" style="width: 60%;"></el-input>
            </div>
          </div>
          <el-button size="mini" @click="createPerfInfo" style="margin-top: 3px;">创建绩效管理规则</el-button>
        </el-card>
        <el-table :data="perfRuleList" fit border stripe="stripe"
                  height="500px" :cell-style="{padding: '5px'}"
                  :header-cell-style="{background:'#eff3f8', color:'#333', padding: '5px'}"
                  :row-style="{height: '0'}"
                  @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            align="center"
            prop="perfTypeCn"
            label="绩效类目" >
          </el-table-column>
          <el-table-column
            align="center"
            label="内容明细" >
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>{{ scope.row.content }}</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag size="mini">{{ scope.row.content }}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="awardTypeCn"
            label="奖励方式">
          </el-table-column>
          <el-table-column
            align="center"
            prop="awardValue"
            label="奖励数额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="addScore"
            label="加分" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="cheFaTypeCn"
            label="惩罚方式" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="cheFaValue"
            label="惩罚数额" >
          </el-table-column>
          <el-table-column
            align="center"
            prop="subScore"
            label="减分" >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      orgId:'',
      userId:'',
      orgList: [],
      filterText: '',
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      //绩效类目
      perfTypeList:[
        {type:1, label:'考核管理'},
        {type:2, label:'财务制度'},
        {type:3, label:'客诉制度'},
        {type:4, label:'荣耀制度'},
      ],
      awardList:[
        {id:1, label:'奖金'},
        {id:2, label:'金章'},
        {id:3, label:'金星'},
        {id:4, label:'银星'},
      ],
      cfList:[
        {id:1, label:'乐捐'},
      ],
      selectPerfTypeId:'',
      selectAwardId:'',
      selectCfId:'',
      perfRuleList:[],
      perfRule:{
        orgId:'',
        perfTypeCn:'',
        content:'',
        awardTypeCn:'',
        cheFaTypeCn:'',
        awardValue:'',
        addScore:'',
        cheFaValue:'',
        subScore:'',
        creator:''
      },
      shopPerfRule:{
        perfRules:[],
        shopIds:[],
        sourceId:'',
      },
      selectedPerfRuleList:[]
    }
  },
  methods:{
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    //组织机构树点击节点方法
    handleCheckChange(data) {
      this.selectOrgId = data.id;
    },
    // 加载机构树
    async loadOrg(){
      const {data:res} = await this.$http.get(`orgList/orgId/${this.orgId}`);
      this.orgList = [res.data];
    },
    filterMethod(query, item){
      return item.orgName.indexOf(query) > -1;
    },
    async createPerfInfo(){
      this.perfRule.orgId = this.orgId;
      this.perfRule.creator = this.userId;
      const {data:res} = await this.$http.post(`/new/perf/rule`, this.perfRule);
      if (res.code === 200){
        this.$message.success("操作成功!");
      }
      this.clear();
      await this.loadPerfInfo();
    },
    async loadPerfInfo(){
      const {data:res} = await this.$http.get(`/load/perf/rule/${this.orgId}`);
      this.perfRuleList = res.data;
    },
    getPerfType(data){
      this.perfRule.perfTypeCn = data;
    },
    getJlType(data){
      this.perfRule.awardTypeCn = data;
    },
    getCfType(data){
      this.perfRule.cheFaTypeCn = data;
    },
    clear(){
      this.perfRule.orgId = '';
      this.perfRule.perfTypeCn = '';
      this.perfRule.content = '';
      this.perfRule.awardTypeCn = '';
      this.perfRule.cheFaTypeCn = '';
      this.perfRule.awardValue = '';
      this.perfRule.addScore = '';
      this.perfRule.cheFaValue = '';
      this.perfRule.subScore = '';
      this.perfRule.creator = '';
      this.selectPerfTypeId = '';
      this.selectAwardId = '';
      this.selectCfId = '';
    },
    async createShopPerfRule(){
      this.shopPerfRule.shopIds = this.$refs.tree.getCheckedKeys();
      this.shopPerfRule.perfRules = this.selectedPerfRuleList;
      this.shopPerfRule.sourceId = this.orgId;
      if (this.shopPerfRule.shopIds.length == 0){
        return this.$message.warning("请选择机构！")
      }
      if (this.shopPerfRule.perfRules.length == 0){
        return this.$message.warning("请选择绩效规则！")
      }
      const {data:res} = await this.$http.post(`/new/shop/perf/rule`, this.shopPerfRule);
      await this.loadShopPerfRule();
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
    },
    loadShopPerfRule(){

    },
    handleSelectionChange(val){
      this.selectedPerfRuleList = val;
    },
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadOrg();
    this.loadPerfInfo();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  //align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}

.left_con{
  //display: flex;
  //justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: 100px;
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
  //flex: 1;
  width: 800px;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/PerfSet.vue